import { render, staticRenderFns } from "./serviceDetailInfo.vue?vue&type=template&id=8b1edc64&scoped=true&"
import script from "./serviceDetailInfo.vue?vue&type=script&lang=js&"
export * from "./serviceDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./serviceDetailInfo.vue?vue&type=style&index=0&id=8b1edc64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1edc64",
  null
  
)

export default component.exports